<div id="my-profile" >
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-user text-mid-dark font-size-h1"></i> {{ "MYPROFILE.PROFILE" | translate }}</h2>

    <div>
        <form
        [formGroup]="profileViewForm"
        novalidate="novalidate"
        >

        <div class="card card-custom gutter-b mt-10">
            <div class="card-body py-0 px-0" >
                <div class="row mx-5 my-5">
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.FIRSTNAME" | translate }}</span>
                        <input type="text" name="inputFirstname" formControlName="inputFirstname" class="form-control inputFirstname" value=""  readonly />
                    </div>
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.SECONDNAME" | translate }}</span>
                        <input type="text" name="inputSecondname" formControlName="inputSecondname" class="form-control inputSecondname" value="" readonly/>
                    </div>
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.LASTNAME" | translate }}</span>
                        <input type="text" name="inputLastname" formControlName="inputLastname" class="form-control inputLastname"  value="" readonly/>
                    </div>
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.SECONDLASTNAME" | translate }}</span>
                        <input type="text" name="inputSecondlastname" formControlName="inputSecondlastname" class="form-control inputSecondlastname"  value="" readonly/>
                    </div>
                </div>
                <div class="separator separator-solid separator-border-2 separator-light"></div>
                
                <div class="row mx-5 my-5">
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.CEDULA" | translate }}</span>
                        <input type="text" name="inputCedula" formControlName="inputCedula" class="form-control" [hiddenInput]="true" mask="XXX-XX-0000" [validation]="true" readonly />
                    </div>
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.RUC" | translate }}</span>
                        <input type="text" class="form-control" readonly />
                    </div>
                </div>
                <div class="separator separator-solid separator-border-2 separator-light"></div>
                
                <div class="row mx-5 my-5">
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.EMAIL" | translate }}</span>
                        <input type="email" name="inputEmail" formControlName="inputEmail" class="form-control inputEmail" readonly/>
                    </div>
                    <div class="col-md-3">
                        <span class="font-size-h5 text-light">{{ "MYPROFILE.PHONE_OFFICE" | translate }}</span>
                        <input type="text" class="form-control" name="inputPhone" formControlName="inputPhone"  mask="+0(000) 000-0000"  [validation]="true" readonly/>
                    </div>
                </div>
                <div class="card-body py-0 px-0" >
                    <div class="row mx-5 my-10">
                        <div class="col-md-12 text-right">
                            <button class="btn btn-success font-weight-bolder" (click)="clickUpdateProfile()"> {{ "INPUT.EDIT" | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </form>

    <!--
    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "GENERAL.LISTING_INSURANCE" | translate }}</h3>
            </div>
        </div>
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th class="text-light">
                            {{ "INSURANCE.DOCUMENT" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "INSURANCE.DOCUMENT_NOMBRE" | translate }}
                        </th>
                        <th>
                            {{ "INSURANCE.DESCARGA" | translate }}
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let document of documentService.items$ | async; let i = index">
                            <td>POLIZA</td>
                            <td>{{ document.NombreDocumento }}</td>
                            <td><button class="btn btn-link"><i class="fas fa-download text-success font-size-h3"></i></button> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    -->
    
    <!--
    <div class="mt-10">
        <div class="row mt-5">
            <div class="col-md-6 col-sm-12">
                <h2 class="mt-5 font-weight-bolder">
                    <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "MYPROFILE.ADDRESS" | translate }}
                </h2>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="col-md-12 col-sm-12 text-right">
                        <button type="button" (click)="clickAddAddress($event)" class="btn btn-lg btn-success font-uppercase font-weight-bolder">{{ "MYPROFILE.ADD_ADDRESS" | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body py-0 px-0 mt-10">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th class="text-light">
                            {{ "MYPROFILE.ADDRESS_TYPE" | translate }}
                        </th>
                        <th class="text-light">
                            {{ "MYPROFILE.ADDRESS" | translate }}
                        </th>
                        <th>
                            {{ "INPUT.EDIT" | translate }}
                        </th>
                        <th>
                            {{ "INPUT.DELETE" | translate }}
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let document of addressService.items$ | async; let i = index">
                            <td>{{ document.Direccion }}</td>
                            <td>{{ document.Direccion }}</td>
                            <td><button class="btn btn-link" (click)="clickToEditAdrress($event); "><i class="fa fa-edit text-success font-size-h3"></i></button> </td>
                            <td><button class="btn btn-link" (click)="clicktoDeleteAdrress($event); "><i class="fa fa-trash text-success font-size-h3"></i></button> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
     </div>
     -->
</div>


<div style="display: none;"><a href="javascript:void(0)" id="open-pdf" target="_blank"></a></div>

<div class="profileModal">
    <ng-template #profileModal let-c="close" let-d="dismiss">
        <form
        [formGroup]="profileForm"
        novalidate="novalidate"
        (ngSubmit)="submitUpdateProfile(loadingModal)"
        >
        <div class="modal-header">
            <h4 class="modal-title">{{ "MYPROFILE.EDITPROFILE" | translate}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div *ngIf="!(profile$ | async)?.length">
                <div class="my-5">
                    <div class="loading-totalesModal">
                        <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "MYPROFILE.LOADPROFILE" | translate }}</span></div>
                    </div>
                </div>
            </div>
            <div *ngIf="(profile$ | async)?.length">
                <!-- begin::Alert error-->
                <ng-container *ngIf="profileHasError">
                    <div class="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                        <div class="alert-text">{{ "INPUT.ERROR_REQUIRED" | translate }}</div>
                    </div>
                </ng-container>
                <!-- end::Alert error-->

                <div class="row">

                    <div class="col-md-12">
                        <div class="form-group row">
                            <label class="col-lg-4 col-form-label">{{ "INPUT.FIRSTNAME" | translate }}</label>
                            <div class="col-lg-8">
                                <input type="text" name="inputFirstname" formControlName="inputFirstname" class="form-control inputFirstname" value="" />
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: profileForm.controls['inputFirstname']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="form-group row mt-5">
                            <label class="col-lg-4 col-form-label">{{ "INPUT.MIDDLENAME" | translate }}</label>
                            <div class="col-lg-8">
                                <input type="text" name="inputSecondname" formControlName="inputSecondname" class="form-control inputSecondname" value="" />
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: profileForm.controls['inputSecondname']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="form-group row mt-5">
                            <label class="col-lg-4 col-form-label">{{ "INPUT.LASTNAME" | translate }}</label>
                            <div class="col-lg-8">
                                <input type="text" name="inputLastname" formControlName="inputLastname" class="form-control inputLastname"  value="" />
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: profileForm.controls['inputLastname']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="form-group row mt-5">
                            <label class="col-lg-4 col-form-label">{{ "INPUT.SECONDLASTNAME" | translate }}</label>
                            <div class="col-lg-8">
                                <input type="text" name="inputSecondlastname" formControlName="inputSecondlastname" class="form-control inputSecondlastname"  value="" />
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: profileForm.controls['inputSecondlastname']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="form-group row mt-5">
                            <label class="col-lg-4 col-form-label">{{ "INPUT.EMAIL" | translate }}</label>
                            <div class="col-lg-8">
                                <input type="email" name="inputEmail" formControlName="inputEmail" class="form-control inputEmail" />
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: profileForm.controls['inputEmail']
                                    }"
                                ></ng-container>
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'email',
                                    message: 'Correo inválido.',
                                    control: profileForm.controls['inputEmail']
                                    }"
                                ></ng-container>
                            </div>
                        </div>

                        <div class="form-group row mt-5">
                            <label class="col-lg-4 col-form-label">{{ "INPUT.CEDULA" | translate }}</label>
                            <div class="col-lg-8">
                                <input type="text" name="inputCedula" formControlName="inputCedula" class="form-control"
                                [hiddenInput]="true" mask="XXX-XX-0000" [validation]="true" />
                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: profileForm.controls['inputCedula']
                                    }"
                                ></ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="modal-footer" >
            <button type="button" class="btn btn-secondary  mr-2" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate }}</button>
            <button type="submit" class="btn btn-success" (click)="submitUpdateProfile(loadingModal)">{{ "INPUT.SUBMIT" | translate }}</button>
        </div>
    </form>
    </ng-template>
</div>

<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>